import { render, staticRenderFns } from "./ConfidenceInterval.vue?vue&type=template&id=706616dc&scoped=true&"
import script from "./ConfidenceInterval.vue?vue&type=script&lang=js&"
export * from "./ConfidenceInterval.vue?vue&type=script&lang=js&"
import style0 from "./ConfidenceInterval.vue?vue&type=style&index=0&id=706616dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706616dc",
  null
  
)

export default component.exports